import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mouse-pointer",
  "use": "mouse-pointer-usage",
  "viewBox": "0 0 289 448",
  "content": "<symbol viewBox=\"0 0 289 448\" id=\"mouse-pointer\"><path d=\"M283.25 260.75c4.75 4.5 6 11.5 3.5 17.25-2.5 6-8.25 10-14.75 10h-95.5l50.25 119c3.5 8.25-.5 17.5-8.5 21L174 446.75c-8.25 3.5-17.5-.5-21-8.5l-47.75-113-78 78c-3 3-7 4.75-11.25 4.75-2 0-4.25-.5-6-1.25-6-2.5-10-8.25-10-14.75V16C0 9.5 4 3.75 10 1.25 11.75.5 14 0 16 0c4.25 0 8.25 1.5 11.25 4.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mouse-pointer.svg
// module id = bCj6
// module chunks = 1